export default "/_next/static/images/6-01b2d27121365364c051ee50448deeb8.png";